export default "__VITE_ASSET__Cl_6oSbY__"